import axios from "@/libs/api.request";
// 获取列表
export const getCurrencyRate = params => {
  return axios.request({
    url: "/finance/CurrencyRate",
    method: "get",
    params
  });
};
// 创建列表
export const add = data => {
  return axios.request({
    url: "/finance/CurrencyRate",
    data,
    method: "post"
  });
};
// 获取详情
export const getDetails = id => {
  return axios.request({
    url: `/finance/CurrencyRate/${id}`,
    method: "GET"
  });
};
// 更新列表
export const update = data => {
  return axios.request({
    url: `/finance/CurrencyRate/${data.id}`,
    method: "put",
    data
  });
};

// 删除列表
export const del = id => {
  return axios.request({
    url: `/finance/CurrencyRate/${id}`,
    method: "DELETE"
  });
};
